'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../utils');

var _translationUtils = require('@wix/photography-client-lib/dist/src/utils/translationUtils');

var _translationUtils2 = _interopRequireDefault(_translationUtils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FullscreenCartButton = function (_React$Component) {
  (0, _inherits3.default)(FullscreenCartButton, _React$Component);

  function FullscreenCartButton(props) {
    (0, _classCallCheck3.default)(this, FullscreenCartButton);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FullscreenCartButton.__proto__ || (0, _getPrototypeOf2.default)(FullscreenCartButton)).call(this, props));

    _this.addToCart = _this.addToCart.bind(_this);
    _this.state = {
      buttonClassNames: 'artstore-add-to-cart-button'
    };
    return _this;
  }

  (0, _createClass3.default)(FullscreenCartButton, [{
    key: 'addToCart',
    value: function addToCart() {
      if (this.props.onAddToCartRequest) {
        this.props.onAddToCartRequest();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var cartItems = this.props.cartItems || [];
      var buttonClassNames = cartItems.length ? 'artstore-add-to-cart-button pro-fullscreen-checkout-link-appears' : 'artstore-add-to-cart-button';

      var buttonDefaultText = _translationUtils2.default ? _translationUtils2.default.getByKey('Gallery_ArtStore_UOU_Add_To_Cart_Button') : '';
      var buttonText = this.props.styleParams.addToCartButtonText || buttonDefaultText;

      return _react2.default.createElement(
        'button',
        {
          className: buttonClassNames,
          tabIndex: _utils.utils.getTabIndex('fullscreenCartButton'),
          'aria-label': buttonText,
          onClick: this.addToCart
        },
        _react2.default.createElement(
          'div',
          null,
          buttonText
        ),
        _react2.default.createElement('div', { className: 'pro-fullscreen-overlay' })
      );
    }
  }]);
  return FullscreenCartButton;
}(_react2.default.Component);

exports.default = FullscreenCartButton;